import { createFileRoute } from '@tanstack/react-router'
import { ExpenseDetailPage } from '../../../../features/finance/expense-pages'

export const Route = createFileRoute('/_app/expenses/$expenseId/')({
  component: ExpenseDetailPage,
})
